module.exports = __webpack_public_path__ + "static/media/Brazil.8fd3bc81.png";